export default "__VITE_ASSET__DgshyTHE__"